import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "lucky-spin-reward-popup" }
const _hoisted_2 = { class: "popup-content" }
const _hoisted_3 = { class: "reward-title" }
const _hoisted_4 = { class: "info-text" }
const _hoisted_5 = { class: "lucky-spin-reward" }
const _hoisted_6 = { class: "reward-row flex" }
const _hoisted_7 = { class: "reward-spin" }
const _hoisted_8 = { class: "flex-1 flex" }
const _hoisted_9 = { class: "reward-type" }
const _hoisted_10 = {
  key: 0,
  class: "reward-amount"
}
const _hoisted_11 = { class: "reward-title" }
const _hoisted_12 = { class: "lucky-spin-reward" }
const _hoisted_13 = {
  key: 0,
  class: "reward-amount"
}
const _hoisted_14 = ["innerHTML"]
const _hoisted_15 = { class: "reward-title large" }
const _hoisted_16 = ["innerHTML"]

import { ref, onMounted } from 'vue';
import { useAudio} from '@/hooks';
import { useAccountStore } from '@/store';


export default {
  __name: 'Reward',
  props: ['rewardItem', 'prizeIndex'],
  emits: ['onClose', 'onSpin'],
  setup(__props, { emit: __emit }) {

const props = __props
const emit = __emit

const { playAudio } = useAudio();

const accountStore = useAccountStore();

onMounted(() => {
  playAudio('open');
  accountStore.fetchBalance();
})

return (_ctx, _cache) => {
  const _component_van_image = _resolveComponent("van-image")
  const _component_van_popup = _resolveComponent("van-popup")
  const _directive_audio = _resolveDirective("audio")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_popup, {
      show: true,
      "close-on-click-overlay": false
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: _normalizeClass(`popup-main prize-${__props.prizeIndex}`)
        }, [
          _createElementVNode("div", _hoisted_2, [
            (Array.isArray(__props.rewardItem))
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('reward.congratulation')) + "!", 1),
                  _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('luckySpin.receivedText')) + ":", 1),
                  _createElementVNode("div", _hoisted_5, [
                    _createVNode(_component_van_image, {
                      class: "reward-icon",
                      fit: "contain",
                      src: require(`@/assets/img/common/reward/type/cash.png`)
                    }, null, 8, ["src"]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.rewardItem, (item, index) => {
                      return (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('common.spin')) + " " + _toDisplayString(index + 1), 1),
                        _createElementVNode("div", _hoisted_8, [
                          _createElementVNode("div", _hoisted_9, ":" + _toDisplayString(_ctx.$t(`luckySpin.rewardType.${item.award}`)), 1),
                          (item.cash)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_10, "+" + _toDisplayString(_ctx.$filter.outputAmount(item.cash)), 1))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    }), 256))
                  ]),
                  _withDirectives((_openBlock(), _createElementBlock("div", {
                    class: "ok-btn",
                    onClick: _cache[0] || (_cache[0] = $event => (emit('onClose')))
                  }, [
                    _createTextVNode(_toDisplayString(_ctx.$t('common.claim').toUpperCase()), 1)
                  ])), [
                    [_directive_audio]
                  ])
                ], 64))
              : (__props.rewardItem.award !== 'good_luck')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t('reward.congratulation')) + "!", 1),
                    _createElementVNode("div", _hoisted_12, [
                      _createVNode(_component_van_image, {
                        class: "reward-icon",
                        fit: "contain",
                        src: require(`@/assets/img/common/reward/type/cash.png`)
                      }, null, 8, ["src"]),
                      (__props.rewardItem.cash)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_13, "P" + _toDisplayString(_ctx.$filter.outputAmount(__props.rewardItem.cash)), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", {
                      class: "info-text",
                      innerHTML: _ctx.$t('luckySpin.receivedText') + ' ' + _ctx.$t(`luckySpin.rewardType.${__props.rewardItem.award}`)
                    }, null, 8, _hoisted_14),
                    _withDirectives((_openBlock(), _createElementBlock("div", {
                      class: "ok-btn",
                      onClick: _cache[1] || (_cache[1] = $event => (emit('onClose')))
                    }, [
                      _createTextVNode(_toDisplayString(_ctx.$t('common.claim').toUpperCase()), 1)
                    ])), [
                      [_directive_audio]
                    ])
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.$t(`luckySpin.rewardType.${__props.rewardItem.award}`)) + "!", 1),
                    _createElementVNode("div", {
                      class: "info-text",
                      innerHTML: _ctx.$t('luckySpin.goodLuckInfo')
                    }, null, 8, _hoisted_16),
                    _withDirectives((_openBlock(), _createElementBlock("div", {
                      class: "ok-btn",
                      onClick: _cache[2] || (_cache[2] = $event => (emit('onClose'), emit('onSpin')))
                    }, [
                      _createTextVNode(_toDisplayString(_ctx.$t('luckySpin.spinAgain')), 1)
                    ])), [
                      [_directive_audio]
                    ])
                  ], 64))
          ])
        ], 2)
      ]),
      _: 1
    })
  ]))
}
}

}